import React from "react";
import styled from "styled-components";

import { Link } from "react-router-dom";

import { device } from "../../theme/device";

const StyledLink = styled(Link)`
  &&& {
    text-decoration: none;
    //margin-top: 40px;
  }
`;

const Title = styled.div`
  padding-top: 2rem;
  color: ${props => props.theme.colorPrimary};
  font-size: 36pt;
  font-weight: bold;
  padding-left: 17.5rem;

  @media (max-width: 1100px) {
    font-size: 37px;
  }

  @media (max-width: 900px) {
    font-size: 28px;
  }

  @media (max-width: 700px) {
    font-size: 19pt;
    padding-left: 2rem;
  }

  @media (max-width: 400px) {
    font-size: 13pt;
    margin-bottom: 1rem;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  position: relative;
  height: auto;
`;

const BaseImage = styled.img`
  width: 100%;
  height: 100%;

  @media (max-width: 700px) {
    height: 60vh;
    object-fit: cover;
    object-position: 50% 100%;
  }

  @media (max-width: 325px) {
    width: 105%;
  }
`;

const TextBlock = styled.div`
  position: absolute;
  bottom: 0px;
  right: 0px;
  left: 167px;
  background-color: black;
  opacity: 0.6;
  color: white;
  padding: 15px;

  @media (max-width: 700px) {
    bottom: 0px;
    right: 0px;
    left: 2rem;
  }

  @media (max-width: 325px) {
    bottom: 7px;
    right: -15px;
    left: 2rem;
    padding-top: 5px;
    padding-bottom: 5px;
  }
`;

const TextLine = styled.p`
  margin-bottom: 0px;
  font-weight: 300;
  font-size: 20pt;

  // @media ${device.phone} {
  //   font-size: 0.9rem;
  // }
  //
  // @media ${device.tabletPortrait} {
  //   font-size: 1.7rem;
  // }

  @media (max-width: 1300px) {
    font-size: 17pt;
  }
  
  @media (max-width: 1200px) {
    font-size: 15pt;
  }
  
  @media (max-width: 1000px) {
    font-size: 13pt;
  }
  
  @media (max-width: 900px) {
    font-size: 11pt;
  }
  
  @media (max-width: 750px) {
    font-size: 10pt;
  }
  
  @media (max-width: 550px) {
    font-size: 10pt;
    font-weight: 600;
  }
  
`;

const BasePage = props => (
  <StyledLink to={{ pathname: props.linkTo }}>
    <Title>{props.title}</Title>
    <ImageContainer>
      <BaseImage src={props.image} />
      <TextBlock>
        <TextLine>{props.textLineOne}</TextLine>
        <TextLine>{props.textLineTwo}</TextLine>
        <TextLine>{props.textLineThree}</TextLine>
      </TextBlock>
    </ImageContainer>
  </StyledLink>
);

export default BasePage;



// WEBPACK FOOTER //
// ./src/UI/BasePage/BasePage.js